import { render, staticRenderFns } from "./FndUserDetail.vue?vue&type=template&id=765de153&"
import script from "./FndUserDetail.vue?vue&type=script&lang=js&"
export * from "./FndUserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports